import { Dialog, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import AcusePDF from '../PDFs/AcusePDF';
import { PDFViewer } from '@react-pdf/renderer';

const MensajeDialog = (props) => {
  const { handleClose, open, data } = props;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen
      maxWidth="md"
    >
      <DialogContent>
        <Typography
          align="center"
          color="primary.gold"
          fontWeight={1000}
          sx={{
            fontSize: 40,
          }}
        >
          Registro Exitoso, gracias.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            mt: 2,
            width: '100%',
            height: '100%',
          }}
        >

          <PDFViewer
            width='100%'
            //height='500px'
            height='100%'

          >
            <AcusePDF cita={data} />
          </PDFViewer>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          pb: 2,
        }}
      >
        <Button
          onClick={() => {
            //Recargar pagina actual
            window.location.reload();
          }}
          variant="contained"
          color="primary"
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog >
  );
};

export default MensajeDialog;
